module.exports = __webpack_public_path__ + "static/orion360_sdk_background-dd83382b1b087a84d60e494e05cf2c21.jpg";